<template>
  <v-expansion-panel :disabled="disabled">
    <v-expansion-panel-header v-slot="{ open }" den>
      <v-row no-gutters>
        <span style="margin-top: 5px">{{ title }}</span>
        <v-spacer/>
        <v-fade-transition>
          <span style="display: inline-flex" v-if="open">
            <v-divider class="mx-1" vertical/>
          </span>
        </v-fade-transition>
      </v-row>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-divider/>
      <v-row dense>
        <v-col cols="12" sm="3" md="3">
          <r-range :model.sync="value.level" label="Level:"/>
        </v-col>
      </v-row>

      <v-row dense class="mt-3">
        <r-guard-rules :items.sync="value.allow" :anyof.sync="value.allowAnyOf" title="Allow"/>
      </v-row>
      <v-row dense>
        <v-divider/>
      </v-row>
      <v-row dense>
        <r-guard-rules :items.sync="value.block" :anyof.sync="value.blockAnyOf" title="Block"/>
      </v-row>
      <v-row dense>
        <v-divider/>
      </v-row>
      <v-row dense class="mt-2">
        <v-col cols="12" sm="6" md="6">
          <v-btn v-if="!isEmptyArray(value.offersAllow)" @click="onOffersAllow" small color="success" class="my-1 fill-width">
            Offers Allow
          </v-btn>
          <v-btn v-else @click="onOffersAllow" small outlined color="primary" class="my-1 fill-width">
            Offers Allow
          </v-btn>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-btn v-if="!isEmptyArray(value.offersBlock)" @click="onOffersBlock" small color="success" class="my-1 fill-width">
            Offers Block
          </v-btn>
          <v-btn v-else @click="onOffersBlock" small outlined color="primary" class="my-1 fill-width">
            Offers Block
          </v-btn>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="6" md="6">
          <r-avatar-dropdown :model.sync="value.avatar" :clearable="true"/>
        </v-col>
        <v-col cols="12" sm="6" md="6" v-if="value.avatar">
          <r-avatar-status :model.sync="value.avatarStatus"/>
        </v-col>
      </v-row>
      <v-row dense class="mt-2">
        <v-col cols="12" sm="6" md="6">
          <r-product-dropdown :model.sync="value.product" :clearable="true"/>
        </v-col>
        <v-col cols="12" sm="6" md="6" v-if="value.product">
          <r-product-status :model.sync="value.productStatus"/>
        </v-col>
      </v-row>
    </v-expansion-panel-content>
    <r-smart-offer-table-dialog ref="smart-offer-table-dialog"/>
  </v-expansion-panel>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {GuardConfig} from "@/modules/redactor/models/guard/GuardConfig";

import RRange from "@/modules/redactor/views/utils/r-range";
import RGuardRules from "@/modules/redactor/views/guard/r-guard-rules";
import RProductDropdown from "@/modules/redactor/views/product/r-product-dropdown.vue";
import RProductStatus from "@/modules/redactor/views/product/r-product-status.vue";
import RSmartOfferTableDialog from "@/modules/redactor/views/smart-offer/r-smart-offer-table-dialog.vue";
import RAvatarDropdown from "@/modules/redactor/views/avatar/r-avatar-dropdown.vue";
import RAvatarStatus from "@/modules/redactor/views/avatar/r-avatar-status.vue";

export default {
  name: "r-guard-panel",
  components: {RAvatarStatus, RAvatarDropdown, RSmartOfferTableDialog, RProductStatus, RProductDropdown, RGuardRules, RRange},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Guard"),
    model: VueTypes.instanceOf(GuardConfig)
  },
  data: () => ({
    items: []
  }),
  computed: {
    value() {
      if (this.model) {
        return this.model;
      } else {
        let value = new GuardConfig();
        this.$emit("update:model", value);
        return value;
      }
    }
  },
  methods: {
    onOffersAllow() {
      this.$refs["smart-offer-table-dialog"].show(ViewRules.UPDATE, this.value.offersAllow, "Offers Allow").then(
          result => {
            this.value.offersAllow = result.map(v => v.uid);
          }, () => {
          });
    },
    onOffersBlock() {
      this.$refs["smart-offer-table-dialog"].show(ViewRules.UPDATE, this.value.offersBlock, "Offers Block").then(
          result => {
            this.value.offersBlock = result.map(v => v.uid);
          }, () => {
          });
    },
    isEmptyArray(value) {
      return !value || value.length === 0;
    }
  }
}

</script>

<style lang="css" scoped>
.fill-width {
  width: 100%;
}
</style>